import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(landing)/pricing/page.tsx");
